import { convertTask, Task, TasksResponse } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

type ReassignTaskVariables = {
  id: string
  assignedTo: string
}

export function useReassignTask() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: reassignTask,
    onSuccess: async () => {
      // Invalidate relevant queries
      await client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function reassignTask({
    id,
    assignedTo,
  }: ReassignTaskVariables): Promise<Task> {
    if (!id) {
      throw new Error('Task ID is required')
    }
    const url = `v2/tasks/custom/reassign/${id}`

    const response = await server.put<TasksResponse.Task>(url, {
      assigned_to: assignedTo,
    })
    return convertTask(response)
  }
}
